import { css } from "@vitality-ds/system";

// eslint-disable-next-line import/prefer-default-export
export var BaseSpinnerWrapper = css({
  svg: {
    marginTop: "unset",
    $$size: "1rem",
    height: "$$size",
    width: "$$size"
  }
});